export const LIST_VIEW = 'list'
export const BLOC_VIEW = 'bloc'
export const NANOLIST_VIEW = 'nanoList'
